import React from "react"
import { Dialog, Grid2 } from "@mui/material"

import { ContainerProps } from "@/components/Dialog/protocols"

import useStyles from "@/components/Dialog/Container/styles"

export const Container = ({
	children,
	open,
	onClose,
	maxWidth,
	fullWidth,
	...props
}: ContainerProps) => {
	const classes = useStyles()

	return (
		<Dialog
			onClose={onClose}
			open={open}
			fullWidth={fullWidth}
			maxWidth={maxWidth || "sm"}
			slotProps={{
				paper: {
					sx: classes.paper
				}
			}}
			{...props}
		>
			<Grid2
				container
				spacing={2}
			>
				{children}
			</Grid2>
		</Dialog >
	)
}
